import styled from 'styled-components';
import { BasicButton } from '../../../component/button';
import { colors } from '../../../component/colors';
import { pxToRem } from '../../../utils/pxToRem';

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  flex: 1;
`;
export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  margin-top: 120px;
`;
export const Title = styled.h1`
  font-size: ${pxToRem(21)};
  font-weight: 500;
  line-height: ${pxToRem(29)};
  letter-spacing: ${pxToRem(0.15000000596046448)};
  text-align: left;
`;
export const AddFeeBtn = styled(BasicButton)`
  width: 120px;
  padding: 11px 0px;
  border-radius: 8px;
`;

export const EditBtn = styled.button`
  background: #f4f5f7;
  mix-blend-mode: normal;
  border-radius: 4px;
  padding: 10px 12px;
  border: none;
  :hover {
    opacity: 0.8;
  }
`;
export const DeleteBtn = styled(EditBtn)`
  margin-left: 12px;
  color: ${colors.danger};
`;
